import { INoticia } from "../../../../Interfaces/model/INoticia";
import {
  PreviewBlock,
  PreviewContainer,
  PreviewImage,
  PreviewMeta,
  PreviewTitle,
} from "./styles";

interface Props {
  news: INoticia;
}

export const Preview = ({ news }: Props) => {
  const contentBlocks = news.conteudo ?? [];

  return (
    <PreviewContainer>
      {news.imagem && <PreviewImage src={news.imagem} alt={news.titulo} />}

      <PreviewTitle>{news.titulo || "Título da notícia"}</PreviewTitle>

      <PreviewMeta>
        {news.autor && <span>{news.autor}</span>}
        {news.cidade && <span>{news.cidade}</span>}
      </PreviewMeta>

      {contentBlocks.map((content, index) => (
        <PreviewBlock key={index}>
          {content.subtitulo && <h3>{content.subtitulo}</h3>}
          {content.imagem && <img src={content.imagem} alt={content.subtitulo} />}
          {content.paragrafo && <p>{content.paragrafo}</p>}
        </PreviewBlock>
      ))}
    </PreviewContainer>
  );
};
